<template>
  <div class="pt-9">
    <h5>{{ section.header }}</h5>
    <p v-html="renderMarkdown(section.text)"></p>
    <v-card flat outlined class="ma-0 pa-4 pl-0" v-if="section.checks">
      <p class="mb-0" v-html="renderChecklist(section.checks)"></p>
    </v-card>
  </div>
</template>

<script>
import marked from 'marked'
import {RulesMixin} from '@/components/mixins'

export default {
  name: 'PreviewInstructionsSection',

  props: {
    section: {}
  },

  data: () => ({}),
  mixins: [RulesMixin],

  methods: {
    renderMarkdown(value) {
      return marked(value)
    },
    renderChecklist(checklist) {
      let result = '<ul class="instructions__checklist">'
      const items = checklist.split('\n').filter(check => !!check)
      items.forEach(item => {
        result += `<li class="py-2"><input class="mr-2 mt-1" type="checkbox"/> <div>${item}</div></li>`
      })
      result += '</ul>'
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  text-transform: none;
}
</style>